export default __webpack_public_path__ + "static/media/physics1a.a11d2d72.JPG";